import React from "react";
import { Box, Grid, Typography, withStyles } from "@material-ui/core";
import ScrollTop from "./ScrollTop";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { Component } from "react";

class PrivacyPolicy extends Component {
  render() {
    const { classes } = this.props;

    return (
      <>
        <Grid container style={{ padding: "15px 35px", minHeight: "100vh" }}>
          <Grid item xs={12} style={{ textAlign: "left" }}>
            {/* Title */}
            <Box mt={4} mb={2}>
              <Typography variant="h4">Privacy Policy</Typography>
              <Typography variant="body2">Last updated: 27-01-2026</Typography>
            </Box>

            {/* Intro */}
            <Typography variant="body2">
              This Privacy Policy describes how <strong>Interface Infosoft Solutions
              Private Limited</strong> (“Company”, “We”, “Us”, or “Our”) collects, uses,
              stores, and shares information when you use the <strong>NecessaryDevil
                </strong> mobile application and website (collectively, the “Service”).
            </Typography>

            <Typography variant="body2" style={{marginTop:"14px"}}>
              By accessing or using the Service, you agree to the collection and
              use of information in accordance with this Privacy Policy. If you
              do not agree, please do not use the Service.
            </Typography>

            {/* 1 */}
            <Section title="1.About NecessaryDevil">
              <Typography variant="body2">
                <strong>NecessaryDevil</strong> is a cloud-based technology platform that enables
                physical and virtual steps/run events, including:
              </Typography>
              <ul
                className={classes.list}
                style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
              >
                <li variant="body2">Event registrations</li>
                <li variant="body2">Event execution and activity tracking</li>
                <li variant="body2">Display of results and leaderboards</li>
                <li variant="body2">
                  Distribution of digital goods to participants and organizers
                </li>
              </ul>
              <Typography variant="body2">
                The platform is owned and operated by <strong>Interface Infosoft
                Solutions Private Limited
                  </strong>, incorporated under the Companies Act,
                2013 (India).
              </Typography>
            </Section>

            {/* 2 */}
            <Section title="2.Definitions">
              <ul
                className={classes.list}
                style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
              >
                <li variant="body2">
                  <strong>Application:</strong> The NecessaryDevil mobile
                  application
                </li>
                <li variant="body2">
                  <strong>Account:</strong> A unique account created to access
                  the Service
                </li>
                <li variant="body2">
                  <strong>Organizer:</strong> Entities hosting events on the
                  platform
                </li>
                <li variant="body2">
                  <strong>Participant/User:</strong> Individuals participating
                  in events
                </li>
                <li variant="body2">
                  <strong>Personal Data:</strong> Any information that
                  identifies or relates to an identifiable individual
                </li>
                <li variant="body2">
                  <strong>Usage Data:</strong> Data collected automatically
                  through use of the Service
                </li>
              </ul>
            </Section>

            {/* 3 */}
            <Section title="3. Information We Collect">
              <SubSection title="3.1 Personal Information You Provide">
                <Typography variant="body2">
                  When you register or participate in events, we may collect:
                </Typography>
                <ul
                  className={classes.list}
                  style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
                >
                  <li variant="body2">Full name</li>
                  <li variant="body2">Email address</li>
                  <li variant="body2">Phone number</li>
                  <li variant="body2">Address (city, state, postal code)</li>
                  <li variant="body2">
                    Profile photo or event-related uploads
                  </li>
                  <li variant="body2">
                    Payment details (processed securely via third-party payment
                    providers)
                  </li>
                </ul>
              </SubSection>

              <SubSection title="3.2 Health, Fitness & Location Data">
                <Typography variant="body2">
                  With your explicit permission, the Application may collect and
                  process the following data during participation in running or
                  endurance events:{" "}
                </Typography>
                <Typography
                  variant="body2"
                  style={{ marginTop: "16px" }}
                ></Typography>

                <Typography variant="body2">
                  <strong>Health & Fitness Data</strong>
                </Typography>
                <ul
                  className={classes.list}
                  style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
                >
                  <li variant="body2">Daily step count</li>
                  <li variant="body2">Activity duration</li>
                  <li variant="body2">Distance covered</li>
                </ul>

                <Typography variant="body2">
                  <strong>Location (GPS) Data</strong>
                </Typography>
                <ul
                  className={classes.list}
                  style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
                >
                  <li variant="body2">
                    Real-time or periodic GPS location during active event
                    tracking
                  </li>
                  <li variant="body2">
                    Running or activity routes mapped using location coordinates
                  </li>
                </ul>

                <Typography variant="body2">
                  <strong>Purpose of Health & Location Data Collection</strong>
                </Typography>
                <ul
                  className={classes.list}
                  style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
                >
                  <li variant="body2">
                    Track running routes and distance accurately
                  </li>
                  <li variant="body2">
                    Measure performance and validate event participation
                  </li>
                  <li variant="body2">
                    Display activity maps, progress, and results within the app
                  </li>
                  <li variant="body2">
                    Enable fair rankings, leaderboards, and event verification
                  </li>
                </ul>

                <Typography variant="body2">
                  <strong>Important Disclosures</strong>
                </Typography>
                <ul
                  className={classes.list}
                  style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
                >
                  <li variant="body2">
                    GPS/Location data is collected only during active event
                    tracking sessions
                  </li>
                  <li variant="body2">
                    Location tracking stops when the activity ends or when
                    permission is revoked
                  </li>
                  <li variant="body2">
                    Health and location data is not used for advertising
                  </li>
                  <li variant="body2">
                    Health and location data is not sold or shared for marketing
                    purposes
                  </li>
                  <li variant="body2">
                    Data is used only for core app functionality and event
                    operations
                  </li>
                </ul>

                <Typography variant="body2">
                  You may grant or revoke access to health or location
                  permissions at any time through your device settings.
                </Typography>
              </SubSection>

              <SubSection title="3.3 Automatically Collected Information">
                <Typography variant="body2">
                  We may automatically collect:
                </Typography>
                <ul
                  className={classes.list}
                  style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
                >
                  <li variant="body2">
                    Device information (device model, OS version)
                  </li>
                  <li variant="body2">IP address</li>
                  <li variant="body2">
                    App usage data (pages viewed, time spent)
                  </li>
                  <li variant="body2">Log and diagnostic data</li>
                </ul>
                <Typography variant="body2">
                  This data helps us improve performance, security, and user
                  experience.
                </Typography>
              </SubSection>

              <SubSection title="3.4 Information Collected from Organizers">
                <Typography variant="body2">
                  If you are an Organizer, we may collect:
                </Typography>
                <ul
                  className={classes.list}
                  style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
                >
                  <li variant="body2">Business and contact details</li>
                  <li variant="body2">Payment and bank information</li>
                  <li variant="body2">
                    Tax-related information (where required by law)
                  </li>
                </ul>
              </SubSection>
            </Section>

            {/* 4 */}
            <Section title="4. How We Use Your Information">
              <Typography variant="body2">
                We use collected information to:
              </Typography>

              <ul
                className={classes.list}
                style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
              >
                <li variant="body2">Provide and operate the Service</li>
                <li variant="body2">Manage registrations and events</li>
                <li variant="body2">
                  Track your daily steps counts and activity duration
                </li>
                <li variant="body2">Update your progress in virtual events</li>
                <li variant="body2">Display results on event leaderboards</li>
                <li variant="body2">
                  Communicate important updates and notifications
                </li>
                <li variant="body2">Provide customer support</li>
                <li variant="body2">Process payments and refunds</li>
                <li variant="body2">
                  Comply with legal and regulatory obligations
                </li>
                <li variant="body2">Improve app functionality and security</li>
              </ul>
            </Section>

            {/* 5 */}
            <Section title="5. Information Access, Monitoring & Disclosure">
              <Typography variant="body2">
                We do not sell personal or health data.
              </Typography>
              <Typography variant="body2">
                We do not disclose personal or health data for advertising or
                marketing purposes. Information is accessed, monitored,
                reviewed, or processed only in the following limited
                circumstances and strictly for operational, legal, or
                service-related purposes:
              </Typography>

              <SubSection title="5.1 Event Monitoring & Management">
                <Typography variant="body2">
                  Limited participant information is made available to Event
                  Organizers solely to monitor participation, verify activities,
                  manage events, and review results related to events hosted on
                  the platform.
                </Typography>
              </SubSection>

              <SubSection title="5.2 Service Operations & Support">
                <Typography variant="body2">
                  Authorized third-party service providers may process or review
                  information on our behalf to support essential functions such
                  as application hosting, analytics, payment processing,
                  customer support, and system maintenance. These providers are
                  contractually bound to protect data and to use it only as
                  instructed by us.
                </Typography>
              </SubSection>

              <SubSection title="5.3 Legal & Regulatory Compliance">
                <Typography variant="body2">
                  Information may be reviewed, accessed, or disclosed where
                  required to comply with applicable laws, regulations, court
                  orders, or lawful requests from government authorities.
                </Typography>
              </SubSection>

              <SubSection title="5.4 Corporate Transactions">
                <Typography variant="body2">
                  In the event of a merger, acquisition, restructuring, or
                  transfer of assets, information may be reviewed or transferred
                  as part of due diligence or business continuity processes,
                  subject to appropriate confidentiality and security safeguards
                </Typography>
              </SubSection>
            </Section>

            {/* 6 */}
            <Section title="6. Data Retention">
              <Typography variant="body2">
                {" "}
                We retain personal data:{" "}
              </Typography>

              <ul
                className={classes.list}
                style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
              >
                <li variant="body2">As long as your account is active</li>
                <li variant="body2">As necessary to provide services</li>
                <li variant="body2">As required by applicable laws</li>
              </ul>
              <Typography variant="body2">
                Backup copies may persist temporarily for legal or security
                purposes.
              </Typography>
            </Section>

            {/* 7 */}
            <Section title="7. Your Rights & Choices">
              <Typography variant="body2"> You have the right to: </Typography>
              <ul
                className={classes.list}
                style={{ paddingLeft: "1.5rem", marginTop: "16px" }}
              >
                <li variant="body2">Access your personal data</li>
                <li variant="body2">
                  Correct or update inaccurate information
                </li>
                <li variant="body2">
                  Request deletion of your account and personal data
                </li>
                <li variant="body2">
                  Withdraw consent for optional data collection
                </li>
              </ul>

              <Typography variant="body2">
                You can request deletion via:
              </Typography>

              <ul className={classes.list}>
                <li>
                  <Typography variant="body2">
                    In-app account settings
                  </Typography>
                </li>

                <li>
                  <Typography variant="body2">
                    Email:&nbsp;
                    <a
                      href="mailto:necessarydevil@interfaceinfosoft.com"
                      className={classes.emailLink}
                    >
                      necessarydevil@interfaceinfosoft.com
                    </a>
                  </Typography>
                </li>
              </ul>
            </Section>

            {/* 8 */}
            <Section title="8. Data Security">
              <Typography variant="body2">
                We implement appropriate technical, administrative, and physical
                safeguards to protect your data. However, no system is
                completely secure, and we cannot guarantee absolute security.
              </Typography>
            </Section>

            {/* 9 */}
            <Section title="9. Children’s Privacy">
              <Typography variant="body2">
                The Service is not intended for children under 13 years of age.
                We do not knowingly collect personal data from children. If such
                data is discovered, it will be deleted promptly.
              </Typography>
            </Section>

            {/* 10 */}
            <Section title="10. Third-Party Links">
              <Typography variant="body2">
                The Service may contain links to third-party websites. We are
                not responsible for their privacy practices and encourage you to
                review their policies.
              </Typography>
            </Section>

            {/* 11 */}
            <Section title="11. Changes to This Privacy Policy">
              <Typography variant="body2">
                We may update this Privacy Policy from time to time. Changes
                will be posted on this page with an updated “Last updated” date.
                Continued use of the Service indicates acceptance of the updated
                policy.
              </Typography>
            </Section>

            {/* 12 */}
            <Section title="12. Contact Us">
              <Typography variant="body2">
                If you have any questions or requests regarding this Privacy
                Policy:
              </Typography>

              <Typography>
                Email: necessarydevil@interfaceinfosoft.com
              </Typography>
              <Typography>
                Website:{" "}
                <a
                  href="https://necessarydevil.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://necessarydevil.com
                </a>
              </Typography>
            </Section>
          </Grid>
        </Grid>

        <ScrollTop />
      </>
    );
  }
}

/* Helpers */
const Section = ({ title, children }) => (
  <Box mt={4}>
    <Typography variant="h5"  fontWeight={700}>
      {title}
    </Typography>
    <Box mt={1}>{children}</Box>
  </Box>
);

const SubSection = ({ title, children }) => (
  <Box mt={3}>
    <Typography variant="h6">{title}</Typography>
    <Box mt={1}>{children}</Box>
  </Box>
);

const styles = () => ({
  list: {
    paddingLeft: "1.5rem",
    marginTop: "16px",
    "& li": {
      marginBottom: "8px",
      fontSize: "16px",
      fontFamily: "Poppins, sans-serif",
      color: "#616161",
    },
  },
});

export default compose(withStyles(styles), withRouter)(PrivacyPolicy);
